import React from 'react';
import PropTypes from 'prop-types';

// Components
import StatusChip from './StatusChip';

/**
 * How many of a room's hubs are reporting, as one chip.
 *
 * Reads "4 hubs" when everything is up and "2/4 hubs offline" when it is not,
 * so a healthy room stays quiet and a degraded one says what is wrong.
 */
export default function MultiHubStatusWidget({ hubs = [], style = {} }) {
  if (hubs.length === 0) return null;

  const connected = hubs.filter((hub) => hub.getIsConnected()).length;
  const offline = hubs.length - connected;
  const unit = hubs.length === 1 ? 'hub' : 'hubs';

  return (
    <StatusChip
      tone={offline === 0 ? 'good' : 'bad'}
      label={offline === 0
        ? hubs.length + ' ' + unit
        : offline + '/' + hubs.length + ' ' + unit + ' offline'}
      style={style}
    />
  );
}

MultiHubStatusWidget.propTypes = {
  hubs: PropTypes.array,
  style: PropTypes.object
};
